import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-95">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-96">
        <div className="absolute top-0 right-0 -mt-10 -mr-10 text-slate-800/50" data-id="element-97">
          <ShieldCheckIcon className="w-64 h-64" data-id="element-98" />
        </div>

        <div className="relative z-10" data-id="element-99">
          <ShieldCheckIcon className="w-16 h-16 text-amber-500 mx-auto mb-6" data-id="element-100" />
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4 tracking-tight" data-id="element-101">
            GARANTÍA TOTAL
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-emerald-400 mb-8" data-id="element-102">
            🛡️ 30 días de garantía incondicional
          </h3>

          <div className="space-y-4 text-lg text-slate-300 leading-relaxed" data-id="element-103">
            <p data-id="element-104">
              Si por cualquier motivo no estás satisfecho con tu compra, te
              devolvemos el 100% de tu inversión sin preguntas y sin burocracia.
            </p>
            <p data-id="element-105">
              No pedimos explicaciones. No ponemos condiciones. Si no es lo que
              esperabas, te devolvemos el dinero.
            </p>
            <p className="font-bold text-white mt-6" data-id="element-106">
              Así de seguros estamos de lo que estás a punto de recibir.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}